import { Control, Controller, FieldError, FieldValues, Path } from 'react-hook-form';
import { NullableValue, SimpleSelectDataItem } from 'src/types';
import { SelectProps, SelectSimple } from '../selects';

export interface SelectPropsWith<T extends FieldValues> extends SelectProps {
  control: Control<T, object>;
  name: Path<T>;
  error?: FieldError | undefined;
  getSelectedId?: (value: SimpleSelectDataItem | NullableValue) => NullableValue;
}

export const SelectWithControl = <T extends FieldValues>({
  name,
  control,
  error,
  getSelectedId,
  ...rest
}: SelectPropsWith<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onBlur, onChange, value } }) => {
        const selectedId = getSelectedId ? getSelectedId(value) : value;
        return <SelectSimple onChange={onChange} selectedId={selectedId} error={error} {...rest} />;
      }}
    />
  );
};
